import React from 'react';
import { UnderConstruction } from '@core/pages';
import { navItems } from '../navigation';

const Invoices: React.FC = () => {
  return <UnderConstruction navItems={navItems} path="/invoices" />;
};

export default Invoices;
